let instance = null;
class JsUtil {
    constructor(){
        if(instance) return instance;
        instance = this;
    }

    /*
    * 소원빌기 영역 선택한 클래스를 제외하곤 display : none으로 전환.
    * [params]
    * className : 클래스명
    *  */
    screen(className){
        let screenList = [
            'p-wish--realname',
            'p-wish--sanctions',
            'p-wish--end',
            'p-wish--on',
        ];
        screenList.forEach(ele=>{

            ele == className ?
                document.getElementsByClassName(ele)[0].style.display = 'block':
                document.getElementsByClassName(ele)[0].style.display = 'none';
        });
    }

    /*
    * DOM 엘리먼트에 텍스트 기입.
    * [params]
    * id : id명
    * value : 기입할 텍스트
    *  */
    inputText(id, value){
        document.getElementById(id).textContent = value;
    }
}

export default JsUtil;


// WEBPACK FOOTER //
// ./src/js/func/util.js